import { useEffect, useRef, useState } from "react";
import { isMobile } from 'react-device-detect';


const Skills = ({ profileData }) => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);



    return (
        <section id="about" ref={sectionRef} className={`${isMobile ? "min-h-screen" : ""} min-h-screen flex items-center justify-center py-20 px-4`}>
            <div className="max-w-6xl mx-auto">
                <h2
                    className={`text-4xl md:text-5xl font-bold text-center mb-16 transition-all duration-1000 ${isVisible
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-10"
                        }`}
                >
                    Technical <span className="text-cyan-400">Skills</span>
                </h2>

                <div className="flex justify-center">
                    <div className={`${isMobile ? "" : "w-2/5"} flex flex-row flex-wrap justify-center gap-4`}>
                        {profileData?.skills?.map((language, index) => (
                            <div
                                key={index}
                                className="layout_2_ flex justify-center text-center py-1 px-2 rounded-lg"
                            >
                                <span className="font-bold text-md">{language}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;
